<template>
    <div>
      <!-- Header -->
      <CRow>
        <CCol col="12" sm="12" class="mb-3">
          <CRow>
            <CCol col="8" sm="10">
              <h5 class="text-muted mt-2">&#128075; Hola! Muy {{ saludoHorario }}, te damos la bienvenida a <strong class="text-dark">&Oacute;ptimo SIM</strong></h5>
              <p>La TRM del dia de hoy es <span class="h5"><strong>${{ $store.state.user.data.TRM }}</strong></span></p>
            </CCol>
            <CCol col="4" sm="2" class="text-right">
              <img :src="urlHeader" alt="" class="img-fluid">
            </CCol>
          </CRow>
        </CCol>
      </CRow>

      <!-- Content -->
      <CRow>
        <CCol col="12" sm="12">
          <CCard>
            <CCardBody>
              <CRow>
                <CCol col="6" sm="3">
                  <img v-if="!urlImagenEmpleado" src="../../public/static/no_user.jpg" alt="Foto empleado" class="c-avatar-img" />
                  <URLImg v-if="urlImagenEmpleado" :url="urlImagenEmpleado" class="c-avatar-img " />
                  <h4 class="text-medium-emphasis text-center mt-3">{{ $store.state.user.data.empleado }}</h4>
                </CCol>

                <!-- Data Customers -->
                <CCol col="12" sm="3">
                  <CCol col="6" sm="12">
                    <CustomerQuantityIndicatorPanel 
                      typeIndicator="AC" 
                      :initialDate="fechaInicial"
                      :finalDate="fechaFinal"
                      :idStaffGroup="$store.state.user.data.tipo_Empleado === 'D' ? $store.state.user.data.id_GrupoPersonal : null"
                      :idEmployee="$store.state.user.data.tipo_Empleado === 'V' ? $store.state.user.data.id_Empleado : null">
                    </CustomerQuantityIndicatorPanel>
                  </CCol>
                  <CCol col="6" sm="12">
                    <CustomerQuantityIndicatorPanel 
                      typeIndicator="CA"
                      :initialDate="fechaInicial" 
                      :finalDate="fechaFinal" 
                      :idStaffGroup="$store.state.user.data.tipo_Empleado === 'D' ? $store.state.user.data.id_GrupoPersonal : null"
                      :idEmployee="$store.state.user.data.tipo_Empleado === 'V' ? $store.state.user.data.id_Empleado : null">
                    </CustomerQuantityIndicatorPanel>
                  </CCol>
                  <CCol col="6" sm="12">
                    <CustomerQuantityIndicatorPanel 
                      typeIndicator="CN"
                      :initialDate="fechaInicial" 
                      :finalDate="fechaFinal" 
                      :idStaffGroup="$store.state.user.data.tipo_Empleado === 'D' ? $store.state.user.data.id_GrupoPersonal : null"
                      :idEmployee="$store.state.user.data.tipo_Empleado === 'V' ? $store.state.user.data.id_Empleado : null">
                    </CustomerQuantityIndicatorPanel>
                  </CCol>
                  <CCol col="6" sm="12">
                    <CustomerQuantityIndicatorPanel 
                      typeIndicator="CP"
                      :initialDate="fechaInicial" 
                      :finalDate="fechaFinal" 
                      :idStaffGroup="$store.state.user.data.tipo_Empleado === 'D' ? $store.state.user.data.id_GrupoPersonal : null"
                      :idEmployee="$store.state.user.data.tipo_Empleado === 'V' ? $store.state.user.data.id_Empleado : null">
                    </CustomerQuantityIndicatorPanel>
                  </CCol>
                  <CCol col="6" sm="12">
                    <CustomerQuantityIndicatorPanel 
                      typeIndicator="PN"
                      :initialDate="fechaInicial" 
                      :finalDate="fechaFinal" 
                      :idStaffGroup="$store.state.user.data.tipo_Empleado === 'D' ? $store.state.user.data.id_GrupoPersonal : null"
                      :idEmployee="$store.state.user.data.tipo_Empleado === 'V' ? $store.state.user.data.id_Empleado : null">
                    </CustomerQuantityIndicatorPanel>
                  </CCol>
                </CCol>

                <!-- Data KPI Sales -->
                <CCol col="12" sm="3">
                  <CCol col="6" sm="12">
                    <div class="puntero" @click="goToSellbills()">
                      <DocumentValuesIndicatorPanel 
                        typeIndicator="Ventas"
                        :initialDate="fechaInicial"
                        :finalDate="fechaFinal"
                        :idStaffGroup="$store.state.user.data.tipo_Empleado === 'D' ? $store.state.user.data.id_GrupoPersonal : null"
                        :idEmployee="$store.state.user.data.tipo_Empleado === 'V' ? $store.state.user.data.id_Empleado : null">
                      </DocumentValuesIndicatorPanel>
                    </div>
                  </CCol>
                  <CCol col="6" sm="12">
                    <div class="puntero" @click="goToDeliveryNote()">
                      <DocumentValuesIndicatorPanel 
                        typeIndicator="Remisiones Periodo"
                        :initialDate="fechaInicial"
                        :finalDate="fechaFinal"
                        :idStaffGroup="$store.state.user.data.tipo_Empleado === 'D' ? $store.state.user.data.id_GrupoPersonal : null"
                        :idEmployee="$store.state.user.data.tipo_Empleado === 'V' ? $store.state.user.data.id_Empleado : null">
                      </DocumentValuesIndicatorPanel>
                    </div>
                  </CCol>
                  <CCol col="6" sm="12" v-if="$store.state.user.data.tipo_Empleado === 'V'">
                    <div class="puntero" @click="goToQuotes()">
                      <DocumentValuesIndicatorPanel
                        typeIndicator="Cotizaciones Periodo"
                        :initialDate="fechaInicial"
                        :finalDate="fechaFinal"
                        :idStaffGroup="$store.state.user.data.tipo_Empleado === 'D' ? $store.state.user.data.id_GrupoPersonal : null"
                        :idEmployee="$store.state.user.data.tipo_Empleado === 'V' ? $store.state.user.data.id_Empleado : null">
                      </DocumentValuesIndicatorPanel>
                    </div>
                  </CCol>
                  <CCol col="6" sm="12">
                    <DocumentValuesIndicatorPanel 
                      typeIndicator="Recaudos"
                      :initialDate="fechaInicial"
                      :finalDate="fechaFinal"
                      :idStaffGroup="$store.state.user.data.tipo_Empleado === 'D' ? $store.state.user.data.id_GrupoPersonal : null"
                      :idEmployee="$store.state.user.data.tipo_Empleado === 'V' ? $store.state.user.data.id_Empleado : null" >
                    </DocumentValuesIndicatorPanel>
                  </CCol>
                  <CCol col="6" sm="12">
                    <DocumentValuesIndicatorPanel 
                      typeIndicator="Cartera" 
                      :initialDate="fechaInicial" 
                      :finalDate="fechaFinal"
                      :idStaffGroup="$store.state.user.data.tipo_Empleado === 'D' ? $store.state.user.data.id_GrupoPersonal : null"
                      :idEmployee="$store.state.user.data.tipo_Empleado === 'V' ? $store.state.user.data.id_Empleado : null" >
                    </DocumentValuesIndicatorPanel>
                  </CCol>
                </CCol>

                  <!-- <CCol col="12" sm="12" v-if="true === false">
                    <CCallout color="s3orange">
                      <span class="text-muted">Compras</span>
                      <br>
                      <Icon icon="tabler:shopping-bag-check" class="text-s3orange mt-1 mr-3" width="28"/>
                      <Icon icon="fluent:shopping-bag-tag-24-regular" class="text-s3orange mt-1 mr-3" width="28"/>
                      <i class="bi bi-bag-check h2 text-s3orange mr-3"></i>
                      <strong class="h4 align-middle">${{ formatter.format(valorCompras, 2) }}M</strong>
                    </CCallout>
                  </CCol> -->


                <CCol col="12" sm="3">
                  <PortfolioParticipationChart 
                    title="Cartera por Edades"
                    reportType="R"
                    sizeColumns="12"
                    :portfolioDays=0
                    :idStaffGroup="$store.state.user.data.tipo_Empleado === 'D' ? $store.state.user.data.id_GrupoPersonal : null"
                    :idEmployee="$store.state.user.data.tipo_Empleado === 'V' ? $store.state.user.data.id_Empleado : null">
                  </PortfolioParticipationChart>
                </CCol>

              </CRow>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>

      <CRow>
        <CCol col="12" sm="6">
          <CCard>
            <CCardBody>
              <CRow>

                <CCol col="12" sm="6">
                  <span class="text-muted font-weight-bold">Utilidad de Ventas</span>
                  <div @click="goToSalesProfit()" class="puntero mt-3">
                    <i class="bi bi-graph-up-arrow h2 text-info mr-3"></i>
                    <strong class="h4 te">Utilidad {{ porcentajeUtilidad }}%</strong>
                  </div>
                  <div class="mt-3">
                    <span>Vr. Venta:</span>
                    <strong class="text-s3green ml-2">${{ formatter.format(valorMercancia, 2) }}M</strong>
                  </div>
                  <div>
                    <span>Vr. Costo:</span>
                    <strong class="text-warning ml-2">${{ formatter.format(valorCosto, 2) }}M</strong>
                    <CProgress 
                      class="mb-1" 
                      color="warning" 
                      size="xs"
                      :value="participacionCosto" 
                    />
                  </div>
                  <div>
                    <span>Vr. Utilidad:</span>
                    <strong class="text-info">${{ formatter.format(valorUtilidad, 2) }}M</strong>
                    <CProgress 
                      class="mb-1" 
                      color="info" 
                      size="xs"
                      :value="participacionUtilidad" 
                    />
                  </div>
                </CCol>

              </CRow>
            </CCardBody>
          </CCard>
        </CCol>


        <!-- <CCol col="12" sm="8">
          <SalesBudgetExecutionChart
            :initialPeriod="periodoInicial"
            :finalPeriod="periodoFinal"
            :idEmployee="$store.state.user.data.tipo_Empleado === 'V' ? $store.state.user.data.id_Empleado : null"
          />
        </CCol> -->


        <!-- <CCol col="12" sm="6" v-if="$store.state.user.data.tipo_Empleado === 'V'">
          <CCard>
            <CCardBody>
              <CRow>
                <CCol col="12" sm="6" class="mt-3">
                  <span class="text-muted">Efectividad Cotizaciones</span>
                  <br>
                  <i class="bi bi-envelope-paper text-s3orange h2 mr-3"></i>
                  <strong class="h4">{{ cantidadCotizacionesRealizadas }}</strong>
                  <br>

                  <span>Facturadas: {{ cantidadCotizacionesFacturadas }}</span>
                  <CProgress
                    :value="((cantidadCotizacionesFacturadas / cantidadCotizacionesRealizadas) * 100)"
                    class="mb-1 bg-white"
                    color="success"
                    size="xs"
                  />
                  <span>Pendientes: {{ cantidadCotizacionesPendientes }}</span>
                  <CProgress
                    :value="((cantidadCotizacionesPendientes / cantidadCotizacionesRealizadas) * 100)"
                    class="mb-1 bg-white"
                    color="warning"
                    size="xs"
                  />

                  <span>Facturadas: ${{ formatter.format(valorCotizacionesFacturadas, 2) }}M</span>
                  <CProgress
                    :value="((valorCotizacionesFacturadas / valorCotizacionesRealizadas) * 100)"
                    class="mb-1 bg-white"
                    color="success"
                    size="xs"
                  />
                  <span>Pendientes: ${{ formatter.format(valorCotizacionesPendientes, 2) }}M</span>
                  <CProgress
                    :value="((valorCotizacionesPendientes / valorCotizacionesRealizadas) * 100)"
                    class="mb-1 bg-white"
                    color="warning"
                    size="xs"
                  />
                </CCol>
              </CRow>
            </CCardBody>
          </CCard>
        </CCol> -->
      </CRow>

      <!-- <CRow v-if="$store.state.user.data.tipo_Empleado === 'V'">
        <CCol col="sm-12">
          <CCard>
            <CCardHeader>
              <CRow>
                <CCol col="sm-12">
                  <h4>Clientes</h4>
                </CCol>
              </CRow>
            </CCardHeader>
            <CCardBody>
              <DirectoryEmployeeDashboard />
            </CCardBody>
          </CCard>
        </CCol>
      </CRow> -->

    </div>
</template>
<script>
  import moment from 'moment'
  // import { Icon } from "@iconify/vue2"
  import { formatter } from '../general'
  import { 
    // dataEfectividadCotizacionesVendedores,
    dataCostoVentasDocumentos
  } from '../apiData'

  import URLImg from '@/components/containers/URLImg.vue'
  import CustomerQuantityIndicatorPanel from "@/components/panels/CustomerQuantityIndicatorPanel.vue";
  import DocumentValuesIndicatorPanel from "@/components/panels/DocumentValuesIndicatorPanel.vue"
  import PortfolioParticipationChart from '@/components/charts/PortfolioParticipationChart.vue'

  // import SalesBudgetExecutionChart from "./charts/SalesBudgetExecutionChart.vue"
  // import DirectoryEmployeeDashboard from "./datagrids/DirectoryEmployeeDashboard.vue"

  export default {
    name: 'HomeEmployee',
    data(){
      return {
        formatter,
        rootPaht: "",
        saludoHorario: "",
        urlHeader: "",
        urlImagenEmpleado: "",
        divisorValores: 1000000,
        fechaInicial: 0,
        fechaFinal: 0,
        // periodoInicial: "",
        // periodoFinal: "",
        valorMercancia: 0,
        valorCosto: 0,
        participacionCosto: 0,
        valorUtilidad: 0,
        participacionUtilidad: 0,
        porcentajeUtilidad: 0
        // cantidadCotizacionesRealizadas: 0,
        // cantidadCotizacionesFacturadas: 0,
        // cantidadCotizacionesPendientes: 0,
        // valorCotizacionesRealizadas: 0,
        // valorCotizacionesFacturadas: 0,
        // valorCotizacionesPendientes: 0
      }
    },
    components: {
      // Icon,
      URLImg,
      CustomerQuantityIndicatorPanel,
      DocumentValuesIndicatorPanel,
      PortfolioParticipationChart
      // SalesBudgetExecutionChart,
      // DirectoryEmployeeDashboard
    },
    created() {
      // Se asignan las variables requeridas antes que se monten los componentes
      this.fechaInicial = moment().startOf("month").format("YYYY-MM-DD")
      this.fechaFinal = moment().format("YYYY-MM-DD")
    },
    async mounted() {
      // await this.$store.dispatch('statusLogin', this.$router)
      this.rootPaht = this.validRootPath(this.$router.currentRoute.fullPath);
      
      const randomNumber = Math.floor(Math.random() * 5) + 1

      this.urlHeader = this.getUrlImg(`imgHeader_0${randomNumber}.png`);

      // this.periodoInicial = moment().format("YYYYMM")
      // this.periodoFinal = this.periodoInicial
      
      if (this.$store.state.user.data.url_ImagenFoto) {
        this.urlImagenEmpleado = `/consultas/api/descargaArchivo?F=${this.$store.state.user.data.url_ImagenFoto}`
      }

      let hora = moment().format("HH")

      if (hora >= 0 && hora < 4) {
        this.saludoHorario = "buena noche"
      } else if (hora >= 4 && hora < 12) {
        this.saludoHorario = "buen día"
      } else if (hora >= 12 && hora < 18) {
        this.saludoHorario = "buena tarde"
      } else {
        this.saludoHorario = "buena noche"
      }

      await this.getDataKPIDocumentUtility()
      if (this.$store.state.user.data.tipo_Empleado === "V") {
        await this.getDataKPIQuotes()
      }
    },
    methods: {
      async getDataKPIDocumentUtility() {
        try {
          const { response } = await dataCostoVentasDocumentos(
            this,
            this.fechaInicial,
            this.fechaFinal,
            "T",
            "venta",
            null,
            this.$store.state.user.data.id_Empleado
          )

          this.valorMercancia = (response[0].Valor_Mercancia / this.divisorValores)
          this.valorCosto = (response[0].Valor_Costo / this.divisorValores)
          this.valorUtilidad = (response[0].Valor_Utilidad / this.divisorValores)

          this.porcentajeUtilidad = response[0].Porcentaje_Utilidad

          this.participacionCosto = ((this.valorCosto / this.valorMercancia) * 100)
          this.participacionUtilidad = ((this.valorUtilidad / this.valorMercancia) * 100)
        } catch (error) {
          console.log(error);
        }
      },
      // async getDataKPIQuotes() {
      //   try {
      //     const { response } = await dataEfectividadCotizacionesVendedores(
      //       this,
      //       this.fechaInicial,
      //       this.fechaFinal,
      //       this.$store.state.user.data.tipo_Empleado === "V" ? this.$store.state.user.data.id_Empleado : null
      //     )

      //     this.cantidadCotizacionesRealizadas = response[0].Cantidad_Realizadas
      //     this.cantidadCotizacionesFacturadas = response[0].Cantidad_Facturadas
      //     this.cantidadCotizacionesPendientes = (this.cantidadCotizacionesRealizadas - this.cantidadCotizacionesFacturadas)

      //     this.valorCotizacionesRealizadas = (response[0].Valor_Realizadas / this.divisorValores)
      //     this.valorCotizacionesFacturadas = (response[0].Valor_Facturadas / this.divisorValores)
      //     this.valorCotizacionesPendientes = (this.valorCotizacionesRealizadas - this.valorCotizacionesFacturadas)
      //   } catch (error) {
      //     console.log(error);
      //   }
      // },
      goToSellbills() {
        this.$router.push(
          {
            path: `${this.rootPaht}/movimientos/facturasventa`
          }
        );
      },
      goToDeliveryNote(){
        this.$router.push(
          {
            path: `${this.rootPaht}/movimientos/entregasmercancia`
          }
        );
      },
      goToQuotes(){
        this.$router.push(
          {
            path: `${this.rootPaht}/movimientos/cotizaciones`
          }
        );
      },
      goToSalesProfit() {
        this.$router.push(
          {
            path: `${this.rootPaht}/indicadores/dashboardventas/utilidadventasdocumentos`
          }
        );
      },
      getUrlImg(str) {
        const images = require.context('../../public/static/img', false, /\.png$/)

        return images(`./${str}`)
      },
      validRootPath(originalPath) {
        let newPath = originalPath;
        let lastChar = originalPath.slice(-1);

        if (lastChar === "/") {
          newPath = originalPath.slice(0, (originalPath.length - 1));
        }

        return newPath;
      }
    }
  }
</script>
